// extracted by mini-css-extract-plugin
export default {"legalContents":"styles__legalContents___fA0ws"};